module.exports = __webpack_public_path__ + "img/2.8e961c17.jpg";